module.exports = __webpack_public_path__ + "assets/images/pages/enqsta/icon-enqsta-1.png?dfc6cf56";